import React, { PropTypes } from 'react';

const SearchFilter = ({ placeholder, handleChange, handleInputFocus }) => (
    <section className="search-section icon-font-before icon-search-solid-before search-section--provider">
        <input
            name="search-section"
            type="text"
            autoComplete="off"
            placeholder={placeholder}
            onChange={handleChange}
            onFocus={handleInputFocus}
        />
    </section>
);

SearchFilter.propTypes = {
    handleChange: PropTypes.func,
    placeholder: PropTypes.string.isRequired,
    handleInputFocus: PropTypes.func
};

export default SearchFilter;



// WEBPACK FOOTER //
// ./app/common/search/SearchFilter.js